'use client';

import { Suspense } from 'react';
import TermsAndConditions from '../components/TermsAndConditions';
import TermsSkeleton from '../components/TermsSkeleton';
import type { TermsAndConditionsData } from '@/types/terms-and-conditions';

interface TermsAndConditionsClientProps {
  locale: string;
  data: TermsAndConditionsData | null;
}

export default function TermsAndConditionsClient({ locale, data }: TermsAndConditionsClientProps) {
  return (
    <Suspense fallback={<TermsSkeleton />}>
      <TermsAndConditions locale={locale} data={data} />
    </Suspense>
  );
}
